module.exports = __webpack_public_path__ + "assets/img/gargoyle-idle.4cbb6db2.png";